import React from "react";
import * as s from "./s.module.scss";

const CTABlock = ({ type, title, description, button }) => {
  let component;

  switch (type) {
    default:
      component = (
        <div className={s.ctaBlock}>
          <div className={s.ctaBlockWrapper}>
            <div className={s.title}>{title}</div>
            <div className={s.content}>
              {description && (
                <div className={s.contentDescription}>{description}</div>
              )}
              {button && <div>{button}</div>}
            </div>
          </div>
        </div>
      );
  }

  return component;
};

export default CTABlock;
